// The read-only Quality view (kanban 808dabf6) — the frontend twin of
// app/auth/quality_viewer.py. One rule, in one place:
//
//     viewer = holds quality:viewer and NOT quality:copilot and NOT agent:console
//
// The EXPLICIT grant narrows, whatever the role: PJ Murphy and Ravi Joshi are
// ADMIN-role executive logins, so `hasScope()` (which short-circuits every
// scope to true for admins) must not be used here — only the explicit scopes
// list the API returns. An admin without the grant (Scott) keeps the full
// door; Jess (quality:copilot) keeps her writable desk.

import type { User } from '../types/auth';

export const QUALITY_VIEWER_SCOPE = 'quality:viewer';
export const QUALITY_COPILOT_SCOPE = 'quality:copilot';
const AGENT_CONSOLE_SCOPE = 'agent:console';

function scopesOf(user: User | null | undefined): string[] {
  return Array.isArray(user?.scopes) ? user.scopes : [];
}

/** True when this person may only LOOK at the Quality door. */
export function isQualityViewer(user: User | null | undefined): boolean {
  const scopes = scopesOf(user);
  if (!scopes.includes(QUALITY_VIEWER_SCOPE)) return false;
  return !scopes.includes(QUALITY_COPILOT_SCOPE) && !scopes.includes(AGENT_CONSOLE_SCOPE);
}

/** True when the door opens for this person at all (viewer or full desk). */
export function canOpenQualityDoor(user: User | null | undefined): boolean {
  if (!user) return false;
  if (user.role === 'ADMIN') return true;
  const scopes = scopesOf(user);
  return scopes.includes(QUALITY_COPILOT_SCOPE) || scopes.includes(QUALITY_VIEWER_SCOPE);
}
